import type { FormatsSliceShape } from './formats-slice'

import { useStore as useZustandStore } from 'zustand'
import { createStore } from 'zustand/vanilla'

import { createFormatsSlice } from './formats-slice'

export type Shape = FormatsSliceShape
export const store = createStore<Shape>()((...args) => ({
	...createFormatsSlice(...args),
}))
export function useAppStore<T>(selector: (state: Shape) => T): T {
	return useZustandStore(store, selector)
}
